import { useEffect } from 'react';
import { startLiveNotificationStream } from '../grpc/notificationStream';

export default function useLiveNotifications(enabled = true) {
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        return startLiveNotificationStream();
    }, [enabled]);
}
